module.exports = __webpack_public_path__ + "images/mmm-06-desktop.png";